import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {    
    
  },
  mutations: {
    SET_PLAYBACK_STATUS(state, boolean) {
      state.audioPlaying = boolean
    },
    SET_FIRSTPLAY_STATUS(state, boolean) {
      state.firstPlay = boolean
    },
    SET_CURRENT_TIME(state, time){
      state.currentTime = time
    },
  },
  state: {
      audioPlaying: false,
      currentTime: 0,
      firstPlay: true,

  },
  strict: process.env.NODE_ENV !== 'production'

})